import { CommonModule } from '@angular/common';
import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { Textarea } from 'primeng/textarea';

import { DriveService } from '@offconon/core-api';

@Component({
  selector: 'offconon-file-properties-form',
  templateUrl: './file-properties-form.component.html',
  styles: ``,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    SelectModule,
    ButtonModule,
    TranslateModule,

    CommonModule,
    Textarea,
  ],
})
export class FilePropertiesFormComponent implements OnInit {
  private fb = inject(FormBuilder);
  private translateService = inject(TranslateService);
  private messageService = inject(MessageService);
  private driveService = inject(DriveService);

  @Input() user_id: any;
  @Input() business_id: any;
  @Input() data: any;
  @Output() formSavedEvent = new EventEmitter<any>();

  private destroyRef = inject(DestroyRef);

  loading = false;
  form: FormGroup;
  media_share_option: any;
  fileName = '';
  extension = '';

  ngOnInit() {
    if (!this.data.file_name || this.data.file_name === '') {
      const fileUrl = this.data.media_file_url || '';

      const fileNameWithExtension = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);

      const dotIndex = fileNameWithExtension.lastIndexOf('.');
      const fileName =
        dotIndex !== -1 ? fileNameWithExtension.substring(0, dotIndex) : fileNameWithExtension;

      this.fileName = fileName;
    } else {
      this.fileName = this.data.file_name;
    }
    if (!this.data.extension || this.data.extension === '') {
      const fileUrl = this.data.media_file_url || '';
      const dotIndex = fileUrl.lastIndexOf('.');
      const extension = dotIndex !== -1 ? fileUrl.substring(dotIndex + 1) : '';
      this.extension = '.' + extension;
    } else {
      this.extension = this.data.extension;
    }

    this.form = this.fb.group({
      id: [this.data.id || null],
      business_id: [this.business_id],
      file_name: [
        this.fileName || '',
        [Validators.maxLength(85), Validators.minLength(2), Validators.required],
      ],
      extension: [this.extension || ''],
      comment: [this.data.comment || '', [Validators.maxLength(85)]],
      description: [this.data.description || '', [Validators.maxLength(125)]],
    });
  }

  submit() {
    let payload: any = {};
    payload = this.form.value;
    let name = payload.file_name;
    name = name.replace(/[^a-zA-Z0-9_-]/g, '-');
    name = name.replace(/\./g, '-');
    name = name.replace(/^-+|-+$/g, '');
    payload.file_name = name;
    this.driveService
      .driveAlbumItemUpdate(
        payload.id,
        payload.business_id,
        payload.comment,
        payload.description,
        name,
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: this.translateService.instant('Successful'),
            detail: this.translateService.instant('Your data has been successfully saved.'),
          });
          this.formSavedEvent.emit(payload);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }
}
